<style>
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.innerRegister {
  margin-left: auto;
  margin-right: auto;
  width: 850px;
}
</style>
<template>
  <div id="register">
    <div :class="{ outer: !$vuetify.breakpoint.mobile }">
      <div :class="{ middle: !$vuetify.breakpoint.mobile }">
        <div :class="{ innerRegister: !$vuetify.breakpoint.mobile }">
          <v-row>
            <v-col>
              <v-card class="rounded-xl" elevation="7">
                <v-form ref="form" class="pa-4 pt-6">
                  <template v-if="!inviterUsername">
                    <p
                      v-if="$store.state.site.whitelabel"
                      class="text-center text-h4"
                    >
                      Register
                    </p>
                    <p
                      v-if="!$store.state.site.whitelabel"
                      class="text-center text-h4"
                    >
                      Register to
                      <span
                        style="
                          font-weight: 500;
                          background: -webkit-linear-gradient(#0179f3, #0190ea);
                          -webkit-background-clip: text;
                          -webkit-text-fill-color: transparent;
                        "
                        >{{ $store.state.site.name }}</span
                      >
                    </p>
                  </template>
                  <template v-else>
                    <p class="text-center text-h4">
                      <strong>{{ inviterUsername }}</strong> has invited you to
                      <span
                        style="
                          font-weight: 500;
                          background: -webkit-linear-gradient(#0179f3, #0190ea);
                          -webkit-background-clip: text;
                          -webkit-text-fill-color: transparent;
                        "
                        >{{ $store.state.site.name }}</span
                      >
                    </p>
                  </template>
                  <v-text-field
                    class="rounded-xl"
                    v-model="username"
                    :outlined="!$store.state.site.whitelabel"
                    color="blue accent-7"
                    label="Username"
                    type="email"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="email"
                    :outlined="!$store.state.site.whitelabel"
                    color="blue accent-7"
                    label="Email"
                    type="email"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-model="password"
                    :outlined="!$store.state.site.whitelabel"
                    color="blue accent-7"
                    label="Password"
                    type="password"
                  ></v-text-field>
                  <v-text-field
                    class="rounded-xl"
                    v-if="!$store.state.site.openRegistrations"
                    v-model="inviteKey"
                    :outlined="!$store.state.site.whitelabel"
                    color="blue accent-7"
                    label="Invite Key"
                    type="code"
                  ></v-text-field>
                  <v-checkbox
                    v-model="tempLogin"
                    label="Logout on refresh"
                  ></v-checkbox>
                  <v-subheader class="pl-0">Fun fact: {{ fact }}</v-subheader>
                  <small v-if="!$store.state.site.whitelabel"
                    >By registering to {{ $store.state.site.name }}, you agree
                    to the
                    <router-link to="/legal/terms"
                      >Terms of Service
                    </router-link>
                    and the
                    <router-link to="/legal/privacy"
                      >Privacy Policy
                    </router-link>
                  </small>
                  <v-divider class="mt-9"></v-divider>
                  <v-card-actions>
                    <v-btn
                      class="rounded-xl"
                      text
                      @click="$router.push('/dashboard')"
                    >
                      Login instead
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="rounded-xl"
                      :loading="loading"
                      color="primary"
                      text
                      @click="doRegister()"
                    >
                      Register
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
export default {
  name: "Register",
  data() {
    return {
      username: "",
      email: "",
      password: "",
      inviteKey: "",
      loading: false,
      tempLogin: false,
      inviterUsername: "",
      captcha: "",
      facts: [],
      fact: "",
      rules: {
        email: (v) => !!(v || "").match(/@/) || "Please enter a valid email",
        length: (len) => (v) =>
          (v || "").length >= len ||
          `Invalid character length, required ${len}`,
        password: (v) =>
          !!(v || "").match(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/
          ) ||
          "Password must contain an upper case letter, a numeric character, and a special character",
        required: (v) => !!v || "This field is required"
      }
    }
  },
  methods: {
    getInviteKey() {
      if (this.$route.params.key) {
        this.inviteKey = this.$route.params.key
        this.axios
          .get("/api/v1/userutils/inviteV2/" + this.inviteKey)
          .then((res) => {
            this.email = res.data.email
            this.inviterUsername = res.data.user?.username
            this.axios
              .get("/api/v1/userutils/fact/" + this.inviteKey)
              .then((res) => {
                this.facts = res.data
                this.fact =
                  this.facts[Math.floor(Math.random() * this.facts.length)]
                setInterval(() => {
                  const fact = this.fact
                  this.fact =
                    this.facts[Math.floor(Math.random() * this.facts.length)]
                  if (fact === this.fact) {
                    this.fact =
                      this.facts[Math.floor(Math.random() * this.facts.length)]
                  }
                }, 5000)
              })
          })
          .catch((e) => {
            this.loading = false
            AjaxErrorHandler(this.$store)(e)
          })
      }
    },
    onCallback(res) {
      this.captcha = res
    },
    onExpire() {
      this.$toast("CAPTCHA has expired.", {
        timeout: 3000,
        type: "error"
      })
    },
    onError(e) {
      this.$toast("CAPTCHA error: " + e, {
        timeout: 3000,
        type: "error"
      })
    },
    doRegister() {
      this.loading = true
      this.axios
        .post("/api/v1/auth/register", {
          username: this.username,
          email: this.email,
          password: this.password,
          inviteKey: this.inviteKey
        })
        .then((res) => {
          this.loading = false
          this.$store.commit("login", res.data)
          if (!this.tempLogin) {
            localStorage.setItem("token", res.data.token)
          }
          this.$store.commit("updateToken", res.data.token)
          Object.assign(this.axios.defaults, {
            headers: { Authorization: this.$store.state.user.token }
          })
          this.axios
            .get("/api/v1/userutils/info")
            .then((res) => {
              this.$store.commit("login", res.data)
              this.$toast(
                "You have been registered.\nThank you for choosing " +
                  this.$store.state.site.name +
                  ".",
                {
                  timeout: 3000,
                  type: "success"
                }
              )
            })
            .catch((e) => {
              AjaxErrorHandler(this.$store)(e)
            })
          this.$router.push("/")
        })
        .catch((e) => {
          this.loading = false
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getInviteKey()
  }
}
</script>

<style scoped></style>
